import { StringHelper } from 'Utilities/StringHelper';

interface IStandardRichTextProps {
  id?: string;
  classNames?: string;
  text: string;
}

const StandardRichText: React.FunctionComponent<IStandardRichTextProps>  = (props) => {
  const hasText = StringHelper.hasNonEmptyString(props.text);
  const classNames = StringHelper.hasNonEmptyString(props.classNames) ? props.classNames : '';
  const text: string = hasText ? props.text : '';

  if (!hasText) return null;

  return (
    <div id={props.id} className={classNames} dangerouslySetInnerHTML={{ __html: text }}></div>
  );
};

export default StandardRichText;